module.exports = __webpack_public_path__ + "media/images/icons/private_customers-fb90000e6a6c22c0014355824dbc49e8.svg";